import DateRangeIcon from "@mui/icons-material/DateRange";
import DateTag from "./DateTag";

const SaleDateTag = (props) => (
  <DateTag icon={<DateRangeIcon />} value={props.value} />
);

export default SaleDateTag;
